import { i18n } from '@/lang'
const $t = i18n.global.t
export default $t
